"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const compareVersions_1 = __importDefault(require("@powerednow/shared/modules/utilities/compareVersions"));
const lodash_1 = require("lodash");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
// eslint-disable-next-line no-redeclare
class Workflow extends complexData_1.default {
    static get allowedAssociations() {
        return {};
    }
    static async getAllHighestVersion(complexObject) {
        const allWorkflows = await this.getAll(complexObject);
        const groupedWorkflows = (0, lodash_1.groupBy)(allWorkflows, 'data.workflowId');
        const highestVersionWorkflows = Object.values(groupedWorkflows).map(workflows => {
            const versions = workflows.map(workflow => workflow.data.version);
            const highestVersion = compareVersions_1.default.getBiggest(...versions);
            return workflows.find(workflow => workflow.data.version === highestVersion);
        });
        return highestVersionWorkflows;
    }
}
Workflow.Entity = entity_1.default;
Workflow.modelProperties = modelProperties_1.default;
exports.default = Workflow;
//# sourceMappingURL=../../../../src/models/workflow/index.js.map